export const spacing = {
  0: 0, 0.5: 2, 1: 4, 1.5: 6, 2: 8, 2.5: 10, 3: 12, 3.5: 14,
  4: 16, 5: 20, 6: 24, 7: 28, 8: 32, 9: 36, 10: 40, 11: 44, 12: 48,
  14: 56, 16: 64, 20: 80, 24: 96, 28: 112, 32: 128, 36: 144, 40: 160,
  44: 176, 48: 192, 56: 224, 64: 256, 80: 320, 96: 384
} as const;

export type SpacingKey = keyof typeof spacing;

export const spacingSemantic = {
  xxs: 2,
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
  xxxl: 64
} as const;

export type SpacingTier = keyof typeof spacingSemantic;

export function px(n: number): string {
  return `${n}px`;
}

export function rem(n: number, base = 16): string {
  return `${n / base}rem`;
}

export function em(n: number, base = 16): string {
  return `${n / base}em`;
}
